import { LoginForm } from './components/LoginForm'

import { useLoginController } from './useLoginController'
import { FormProvider } from 'react-hook-form'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { SwiperSlide, Swiper } from 'swiper/react'
import { Logo } from '@/view/components/ui/logo'

import login from '../../../assets/login.png'

export const Login = () => {
  const { methods, banners, isLoading } = useLoginController()

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center xl:flex-row xl:justify-start">
      {!isLoading && banners && (
        <section className="hidden h-screen shrink-0 xl:block xl:w-[66.667vh] xl:max-w-[50vw]">
          {banners?.banners?.length > 0 ? (
            <Swiper
              modules={[Autoplay, Pagination, Navigation]}
              spaceBetween={0}
              slidesPerView={1}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
                el: '.swiper-pagination',
                bulletActiveClass: 'bg-primary',
                bulletClass:
                  'inline-block w-1.5 h-1.5 rounded-full bg-white/50 mx-1 cursor-pointer transition-all',
              }}
              navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }}
              loop={true}
              className="h-full w-full"
            >
              {banners.banners.map((banner, index) => (
                <SwiperSlide key={index} className="z-0 flex h-full">
                  <a
                    href={banner.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex h-full w-full items-center justify-center"
                  >
                    <img
                      src={`${import.meta.env.VITE_CDN_URL}${banner.uri}`}
                      alt=""
                      className="h-full w-full object-cover"
                      loading="lazy"
                    />
                  </a>
                </SwiperSlide>
              ))}

              <div className="swiper-pagination !bottom-2"></div>
            </Swiper>
          ) : (
            <img
              src={login}
              alt=""
              className="h-full w-full object-contain object-left"
              loading="lazy"
            />
          )}
        </section>
      )}
      <section className="flex w-full flex-col items-center justify-center px-8">
        <div className="mb-8">
          <Logo />
        </div>
        <FormProvider {...methods}>
          <div className="flex flex-col gap-8 text-black03">
            <h1 className="md:text-2l font-semibold lg:text-3xl">Entrar</h1>
            <LoginForm />
          </div>
        </FormProvider>
      </section>
    </div>
  )
}
